import Plan from '@/classes/Plan'
import { Session } from '@/classes/Session'
import type { SessionAnalyticsData, SessionData } from '@/types'
import { DateTime } from 'luxon'
import { faker } from '@faker-js/faker'
import { DeckFlavor } from '@/enums/Language'

export default function SessionFactory(
	plans: Plan[],
	props: Partial<SessionData> = {}
): Session {
	const planIds: string[] = plans.map((plan) => plan.id)
	const lastUpdated: string = new Date().toISOString()


	return new Session({
		planIds,
		lastUpdated,
		...props,
	})
}

export function AnalyticsFactory(props: Partial<SessionAnalyticsData> = {}){
	return {
		presentationStartAt: DateTime.now().toISO(),
		slides: [],
		slideDeckId: faker.string.uuid(),
		slideDeckLocalization: faker.helpers.arrayElement(Object.values(DeckFlavor)),
		slideDeckVersion: DateTime.now().minus({ days: 3 }).toISO(),
		...props
	}
}
